import PaymentMethods from "@/components/settings/billing/payment/PaymentMethods";
import {useAuth} from "@/libs/auth";
import {useCallback, useEffect, useState} from "react";
import {retrieveCustomer, updateDefaultMethod} from "@/services/stripe-store";

const SetDefaultPayments = (props: { cid: string }) => {
  const {token, user} = useAuth()

  const [defaultMethod, setDefaultMethod] = useState("");

  const updateDefaultPay = useCallback((methodId: string) => {
    const original = defaultMethod
    setDefaultMethod(methodId);

    updateDefaultMethod(token, props.cid, methodId)
      .then((resp: any) => {
        if (resp.status != 200) {
          setDefaultMethod(original)
        }
      })
  }, [defaultMethod, props.cid, token]);

  useEffect(() => {
    if (props.cid) {
      retrieveCustomer(token, props.cid).then((result) => {
        setDefaultMethod(result.data?.invoice_settings?.default_payment_method)
      })
    }
  }, [props.cid, token, user])

  return (
    <div>
      <PaymentMethods initialMethodId={defaultMethod} updateMethod={updateDefaultPay} type={"Default"} cid={props.cid}/>
    </div>
  )
}

export default SetDefaultPayments
